export class JobMetadata {
  public AddInVersion: string;
  public AttachmentFileSizeBytes: number;
  public CompanyName: string;
  public DesktopPlatform: string;
  public ModelFileSizeBytes: number;
  public ModelName: string;
  public NumAssemblies: number;
  public NumAttachments: number;
  public NumFabParts: number;
  public NumParts: number;
  public ProjectName: string;
  public UserDisplayName: string;
  public UserEmail: string;
  public WorkflowName: string;
  
  constructor() {
    this.AddInVersion = '';
    this.AttachmentFileSizeBytes = 0;
    this.CompanyName = '';
    this.DesktopPlatform = '';
    this.ModelFileSizeBytes = 0;
    this.ModelName = '';
    this.NumAssemblies = 0;
    this.NumAttachments = 0;
    this.NumFabParts = 0;
    this.NumParts = 0;
    this.ProjectName = '';
    this.UserDisplayName = '';
    this.UserEmail = '';
    this.WorkflowName = '';
  }
}
